import axiosInstance from '../../api/auth/axiosInstance';
import Swal from 'sweetalert2';
export const CreateInvoiceService = {
     fetchPatient1: async (patientId,comId) => {
    try {
      const response = await axiosInstance.get(`/patients/${patientId}/${comId}`,{
        headers: {
          authType:"PostLogin"
      }});
      return response;
    } catch (error) {
      console.error("Error fetching patients details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching patients details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },


fetchPatientNameOrNum: async (ptNameNum,companyId,config = {}) => {
    try {
      const { signal } = config; // <- IMPORTANT
      const response = await axiosInstance.get(
  `/patients/patient-name-num/${ptNameNum}/${companyId}`,
  {
    signal, // request cancel signal
    headers: {
      authType: "PostLogin"
    }
  }
);
return response;
    } catch (error) {
      console.error("Error fetching patients details:", error);
      throw error;
    }
  },
    fetchPatientFull: async (id) => {
    try {
      const response = await axiosInstance.get(`/patients/patient-id/${id}`,{
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error fetching patients details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching patients details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
  fetchDoctors: async (companyId) => {
    try {
      const response = await axiosInstance.get(
        `/users/search-doctors/by-company/${companyId}`,{
          headers: {
            authType: "PostLogin"
        } }
      );
      return response;
    } catch (error) {
      console.error("Error fetching doctors:", error);
      Swal.fire({
        title: 'Failed!',
        text: `Error fetching doctors: ${(error.response?.data?.statusDescription || error.message)}`,
        icon: 'error',
        confirmButtonColor: '#566fe2',
        customClass: {
          title: 'swal-title-small',
          popup: 'swal-popup-small',
          confirmButton: 'swal-button-small'
        }
      });
      throw error;
    }
  },
  updateInvoice: async (invoiceId, formData) => {
    try {
      const response = await axiosInstance.put(`/create-invoice/update/${invoiceId}`, formData,{
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error updating invoice details:", error);
      Swal.fire({
        title: 'Failed!',
        text: `Error updating invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
        icon: 'error',
        confirmButtonColor: '#566fe2',
        customClass: {
          title: 'swal-title-small',
          popup: 'swal-popup-small',
          confirmButton: 'swal-button-small'
        }
      });
      throw error;
    }
  },
    fetchTestsTreats: async (comId) => {
    try {
      const response = await axiosInstance.get(`/treatment-service/tests/${comId}`,{
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error fetching patients details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching patients details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
   insertInvoices: async (formData) => {
    try {
      const response = await axiosInstance.post(`/create-invoice/`,formData,{
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error inserting invoice details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
    getInvoiceByDate: async (fromDate,toDate,comId, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/create-invoice/by-date/company-id/${comId}?fromDate=${fromDate}&toDate=${toDate}`,
         {
          params: { page, size },
        headers: {
          authType: "PostLogin"
      } }
     );
      return response;
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
    getInvoiceBySearchTermWithDate: async (searchTerm,fromDate,toDate,comId, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/create-invoice/search-term/company-id/${searchTerm}?fromDate=${fromDate}&toDate=${toDate}&comId=${comId}`,
      {
        params: { page, size },
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
  getInvoiceByCompany: async (comId, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/create-invoice/company-id/${comId}`, {
        params: { page, size },
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
  getInvoiceByInvoiceId: async (invoiceId) => {
    try {
      const response = await axiosInstance.get(`/create-invoice/invoice-id/${invoiceId}`, {
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
  getInvoiceByPatient: async (patId, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/create-invoice/patient-id/${patId}`, {
        params: { page, size },
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
  getInvoiceBySearchTerm: async (searchTerm, page = 0, size = 10) => {
    try {
      const response = await axiosInstance.get(`/create-invoice/search-term/${searchTerm}`, {
        params: { page, size },
        headers: {
          authType: "PostLogin"
      } });
      return response;
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      Swal.fire({
  title: 'Failed!',
  text: `Error fetching invoice details: ${(error.response?.data?.statusDescription || error.message)}`,
  icon: 'error',
  confirmButtonColor: '#566fe2', // your custom button color
  customClass: {
    title: 'swal-title-small',
    popup: 'swal-popup-small',
    confirmButton: 'swal-button-small'
  }
});
      throw error;
    }
  },
};